import $ from 'jquery';

import './onlineOffline.scss';

export default function init( pluginApi ) {
  showOrHideElementsForConnectivity( pluginApi.networkStatus );
  pluginApi.addAction( 'network_status_changed', 'asmag_reader_plugin', showOrHideElementsForConnectivity );
}

function showOrHideElementsForConnectivity( isOnline ) {
  if ( isOnline ) {
    $('html, body').removeClass('asmag-offline');
    $('html, body').addClass('asmag-online');
  }
  else {
    $('html, body').removeClass('asmag-online');
    $('html, body').addClass('asmag-offline');
  }
}
